import React from 'react'
import PropTypes from 'prop-types'
import { Text, Tooltip } from '@plurall/elo-beta'
import styles from './TableCell.module.scss'

interface ITableCellProps {
  title: string
  dataTestId: string
  cellWidth: number
  size?: string
  element?: string
  variant?: string
  onClick?: () => void
}

const TableCell = ({ title, dataTestId, cellWidth, ...textProps }: ITableCellProps) => {
  return (
    <Tooltip title={title || '---'} position='top'>
      <div className={styles['table-cell-container']} style={{ maxWidth: `${cellWidth}px` }}>
        <Text
          {...textProps}
          size='t3'
          className={`${styles['table-cell']}`}
          css={{ maxWidth: `${cellWidth}px` }}
          dataTestId={dataTestId}
        >
          {title || '---'}
        </Text>
      </div>
    </Tooltip>
  )
}

export default TableCell
